<template>
  <div>
    <h1>Konto angelegt</h1>

    <el-card>
      <el-alert
        :closable="false"
        show-icon
        title="Vielen Dank für das Erstellen eines neuen Kontos."
        type="success"
      />

      <el-alert
        :closable="false"
        show-icon
        title="Bitte bestätigen Sie Ihre E-Mail-Adresse mit dem Link, der Ihnen zugesendet wurde."
        type="warning"
      />
    </el-card>

    <p>Sobald Sie Ihre E-Mail-Adresse bestätigt haben, können Sie sich anmelden. Bei der ersten Anmeldung können Sie Ihren Konto-Typ auswählen (<strong>Coach</strong> oder <strong>Coachee</strong>).</p>
  </div>
</template>

<script>
export default {
  name: 'VSignupSuccess',

  metaInfo: {
    title: 'Registrierung erfolgreich'
  }
}
</script>
